









import { Component, Vue } from 'vue-property-decorator';
import IconCart from '@/components/icons/IconCart.vue';

@Component({
  components: {
    IconCart,
  },
})
export default class EmptyBag extends Vue {
}
